import { c as _c } from "react/compiler-runtime";
import { Icon } from '@/shared/ui/atoms';
import { CustomButton } from '@/shared/ui/molecules';
interface FilterResetButtonProps {
  handleResetReviewFilter: () => void;
  subject: string;
  major: string;
  minor: string;
}
const FilterResetButton = t0 => {
  const $ = _c(6);
  const {
    handleResetReviewFilter,
    subject,
    major,
    minor
  } = t0;
  const hasFilter = subject || major || minor;
  if (!hasFilter) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon src="/icons/reset-icon.svg" width={16} height={16} alt={"\uCD08\uAE30\uD654"} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== handleResetReviewFilter) {
    t2 = <CustomButton className="shrink-0 rounded-full border border-gray-200 px-4 py-2" onClick={handleResetReviewFilter}>{t1}</CustomButton>;
    $[1] = handleResetReviewFilter;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="inline-block h-5 w-px shrink-0 bg-gray-200" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <>{t2}{t3}</>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default FilterResetButton;